import IState from '../models/IState';
import { createSelector } from "reselect";

const stateSensorDataChart = (state: IState) => state.sensorDataChart.sensorDataChartList.datas;

export const allSensorDataChart = createSelector(
    stateSensorDataChart,
    (datas) => {
        if (datas !== null) {
            return datas;
        }
        return [];
    }
)

